import { DeleteIcon } from '../../../common/components/icons';
import React, { useState } from 'react';
import styled from 'styled-components';
import { copilotApi } from '../api/chatApi';

const ConversationSnippet = styled.div<{ isHovered: boolean }>`
  display: flex;
  flex-direction: row;
  font-family: Poppins;
  font-size: 14px;
  cursor: pointer;
  background: ${({ isHovered }) => (isHovered ? '#F8FAFF' : 'white')};
  color: ${({ isHovered }) => (isHovered ? '#2d70e2' : '#2A3039')};
  font-weight: ${({ isHovered }) => (isHovered ? '600' : '400')};
  border-radius: 8px;
`;

const ConversationName = styled.div`
  color: ${({ color }) => color};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 4px 6px;
`;

const DeleteIconWrapper = styled.div`
  margin-left: 6px;
  align-self: center;
`;

type CopilotChatThreadProps = {
  threadName: string;
  threadId: number;
  selectedThreadId: number | undefined;
  onClick: (threadId: number) => void;
  onThreadDeleted: (threadId: number) => void;
};

const CopilotChatThread = (props: CopilotChatThreadProps) => {
  const { threadId, threadName, selectedThreadId } = props;
  const [isHovered, setIsHovered] = useState(false);
  const [deleteThread] = copilotApi.useApiPortalV1ChatCopilotDestroyMutation();

  const handleDelete = async (e: any) => {
    e.stopPropagation();
    await deleteThread({ id: typeof threadId === 'string' ? Number(threadId) : threadId });
    props.onThreadDeleted(threadId);
  };

  function getColor() {
    return isHovered || threadId === selectedThreadId ? '#2d70e2' : '#666D79';
  }
  function getIconColor() {
    return isHovered || threadId === selectedThreadId ? '#2d70e2' : '#666D79';
  }

  return (
    <ConversationSnippet
      key={threadId}
      as="div"
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      isHovered={isHovered}
      onClick={() => {
        props.onClick(threadId);
      }}
    >
      <ConversationName color={getColor()}>{threadName}</ConversationName>
      <DeleteIconWrapper onClick={handleDelete}>
        <DeleteIcon fill={getIconColor()} />
      </DeleteIconWrapper>
    </ConversationSnippet>
  );
};

export default CopilotChatThread;
